import {connect} from 'react-redux';

import {CalendarsPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getCalendarWeekStartDay} from '../../../../store/data/preferences/preferencesSelectors';
import {
  updateRepeatingAvailabilityAction,
  updateStandardAvailabilityAction,
} from '../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingActions';
import {
  getDraftSchedulingLink,
  getSchedulingPanelIsPopout,
  getSelectedRepeatingSlots,
  getSelectedStandardSlots,
} from '../../../../store/panels/calendars/scheduling/calendarsPanelSchedulingSelectors';
import {SchedulingLinkSettingsCalendarDialog} from './schedulingLinkSettingsCalendarDialog';

/*
 * Props.
 */

interface SchedulingLinkSettingsCalendarDialogContainerProps {
  panelId: CalendarsPanelId;
  onRequestClose: () => void;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SchedulingLinkSettingsCalendarDialogContainerProps>()(() => ({
  draftLink: getDraftSchedulingLink,
  weekStartDay: getCalendarWeekStartDay,
  initialStandardSlots: getSelectedStandardSlots,
  initialRepeatingSlots: getSelectedRepeatingSlots,
  isPopout: getSchedulingPanelIsPopout,
}));

const mapDispatchToProps = makeMapDispatchToProps<SchedulingLinkSettingsCalendarDialogContainerProps>()(
  ({panelId}) => ({
    onUpdateStandardSlots: (newSlots) => updateStandardAvailabilityAction(panelId, newSlots),
    onUpdateRepeatingSlots: (newSlots) => updateRepeatingAvailabilityAction(panelId, newSlots),
  }),
);

export const SchedulingLinkSettingsCalendarDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SchedulingLinkSettingsCalendarDialog);
